import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import regeneratorRuntime from "/home/vsts/work/1/s/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getProfileSuggestion } from "@queries/profile-search";
import { profileTypesData } from "@utils/helpers/profile-data";
import isEmpty from "lodash/isEmpty";
import router from "next/router";
import React, { useEffect, useRef, useState } from "react";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var requestNumber = 0;
var selectedProfile = false;
var Search = function(param) {
    var _defaultValue = param.defaultValue, defaultValue = _defaultValue === void 0 ? "" : _defaultValue, type = param.type;
    var ref = useState(defaultValue), searchQuery = ref[0], setSearchQuery = ref[1];
    var ref1 = useState(""), inputMessage = ref1[0], setInputMessage = ref1[1];
    var ref2 = useState([]), results = ref2[0], setResults = ref2[1];
    var ref3 = useState(false), showEmpty = ref3[0], setShowEmpty = ref3[1];
    var nodeRef = useRef(null);
    var handleClick = function(event) {
        if (!nodeRef.current.contains(event.target)) {
            setShowEmpty(false);
            setResults([]);
            setInputMessage("");
        }
    };
    var handleSearch = function() {
        return __awaiter(void 0, void 0, void 0, regeneratorRuntime.mark(function _callee() {
            var _requestNumber, response, items;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setShowEmpty(false);
                        if (!(searchQuery === "")) {
                            _ctx.next = 4;
                            break;
                        }
                        setInputMessage("");
                        return _ctx.abrupt("return");
                    case 4:
                        requestNumber += 1;
                        _requestNumber = requestNumber;
                        setInputMessage("loading...");
                        _ctx.prev = 7;
                        _ctx.next = 10;
                        return getProfileSuggestion(searchQuery, profileTypesData[type].endPointAlias, 200);
                    case 10:
                        response = _ctx.sent;
                        items = response.data.items;
                        if (!(_requestNumber !== requestNumber)) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 14:
                        if (isEmpty(items) && type === "targets") {
                            setInputMessage("");
                            setShowEmpty(true);
                        } else if (isEmpty(items)) {
                            setInputMessage("No results found");
                        } else {
                            setInputMessage("".concat(items === null || items === void 0 ? void 0 : items.length, " out of ").concat(items === null || items === void 0 ? void 0 : items.length));
                        }
                        setResults(items);
                        _ctx.next = 21;
                        break;
                    case 18:
                        _ctx.prev = 18;
                        _ctx.t0 = _ctx["catch"](7);
                        console.error(_ctx.t0);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    7,
                    18
                ]
            ]);
        }));
    };
    var handleProfileSelect = function(data) {
        selectedProfile = true;
        setSearchQuery("".concat(data === null || data === void 0 ? void 0 : data[profileTypesData[type].completeNameKey], " ").concat((data === null || data === void 0 ? void 0 : data.optionalName) ? " (".concat(data === null || data === void 0 ? void 0 : data.optionalName, ")") : ""));
        setShowEmpty(false);
        setResults([]);
        setInputMessage("");
        router.push("/".concat(type, "/").concat(data.encodedName));
    };
    useEffect(function() {
        if (defaultValue) {
            setSearchQuery(defaultValue);
        }
    }, [
        defaultValue
    ]);
    var ref4 = useState(searchQuery), debouncedSearchQuery = ref4[0], setDebouncedSearchQuery = ref4[1];
    useEffect(function() {
        var handler = setTimeout(function() {
            setDebouncedSearchQuery(searchQuery);
        }, 600);
        return function() {
            clearTimeout(handler);
        };
    }, [
        searchQuery
    ]);
    useEffect(function() {
        if (debouncedSearchQuery !== defaultValue && !selectedProfile) {
            handleSearch();
        }
        selectedProfile = false;
    }, [
        debouncedSearchQuery,
        defaultValue,
        selectedProfile
    ]);
    useEffect(function() {
        document.addEventListener("mousedown", handleClick);
        return function() {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: "w-full lg:w-1/2",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mb-2 relative",
            ref: nodeRef,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "absolute mr-2 mt-2 text-sm text-gray-400 right-2",
                    children: inputMessage
                }),
                /*#__PURE__*/ _jsx("input", {
                    value: searchQuery,
                    onChange: function(event) {
                        return setSearchQuery(event.target.value);
                    },
                    className: "w-full pl-4 pr-12 py-2 border border-gray-1000 focus:border-altPrimary focus:shadow-inner",
                    placeholder: "Enter a ".concat(profileTypesData[type].label),
                    type: "text"
                }),
                showEmpty && /*#__PURE__*/ _jsx("ul", {
                    className: "w-full absolute z-10 bg-white max-h-72 py-4 border-altPrimary border-2 border-l",
                    children: /*#__PURE__*/ _jsx("li", {
                        className: "pl-4 py-2",
                        children: "Target not found. The name may have been adjusted. Please try searching in Target profile"
                    })
                }),
                (results === null || results === void 0 ? void 0 : results.length) > 0 && /*#__PURE__*/ _jsx("ul", {
                    className: "w-full absolute z-10 overflow-scroll bg-white max-h-72 py-4 border-altPrimary border-2 border-l",
                    children: results.map(function(item) {
                        return /*#__PURE__*/ _jsx("li", {
                            className: "pl-4 hover:bg-primary hover:text-white py-2",
                            onClick: function() {
                                return handleProfileSelect(item);
                            },
                            children: /*#__PURE__*/ _jsxs("span", {
                                className: "w-full block cursor-pointer",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "hover:underline",
                                        children: type === "companies" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                item === null || item === void 0 ? void 0 : item.companyNameWdba,
                                                " ",
                                                (item === null || item === void 0 ? void 0 : item.optionalName) ? (item === null || item === void 0 ? void 0 : item.companyNameWdba.toLocaleLowerCase().includes(item === null || item === void 0 ? void 0 : item.optionalName.toLocaleLowerCase())) ? "" : " (".concat(item === null || item === void 0 ? void 0 : item.optionalName, ")") : ""
                                            ]
                                        }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                item === null || item === void 0 ? void 0 : item[profileTypesData[type].completeNameKey],
                                                " ",
                                                (item === null || item === void 0 ? void 0 : item.optionalName) ? (item === null || item === void 0 ? void 0 : item.optionalName.toLocaleLowerCase().includes(searchQuery.toLocaleLowerCase())) ? " (".concat(item === null || item === void 0 ? void 0 : item.optionalName, ")") : "" : ""
                                            ]
                                        })
                                    }),
                                    type === "companies" && (!item.active || item.isArchived) && /*#__PURE__*/ _jsx("span", {
                                        className: "text-red-600 font-bold",
                                        children: "*"
                                    })
                                ]
                            })
                        }, item.id);
                    })
                })
            ]
        })
    });
};
export default Search;
